import { z } from "zod";
import { config } from "../config";
import { ENTRY } from "../helpers/getEnv";
import engageApps from "./apps.engage.json";
import mmAppsLocal from "./apps.mm.functionaltest.json";
import mmApps from "./apps.mm.json";
const mfeNames = [
  "AccountDetails",
  "AccountCenterAccounts",
  "AccountCenterInvite",
  "AccountAdminCenterAccounts",
  "Analytics",
  "Billing",
  "BotBuilder",
  "BotBuilderV2",
  "Campaigns",
  "CampaignsCore",
  "CampaignsHermes",
  "CampaignsIris",
  "Channels", // New engage
  "ChannelsEngage", // Classic engage
  "Contact",
  "Customers",
  "Devtools",
  "EngageUI",
  "Home",
  "Menu",
  "Personalisation",
  "PromotionTools",
  "PurchaseFlow",
  "Settings",
  "SignUp",
  "TemplateManager",
  "HTMXInbox",
  "CopAiAssistant",
  "CopLogs",
  "CopCommonSip",
  "CopCommon",
  "CopFax",
  "CopElasticSipTrunking",
  "CopInsights",
  "CopNumberLookup",
  "MfeBilling",
  "MfeDashboard",
  "SinchId",
  "container",
  "MfeAccount",
  "MfeLogin",
  "MfeEcommerce",
  "MfeAutomations",
  "MfeIntegrations",
  "MfeInternalUserManagement",
  "MfeUserManagement",
  "SinchConnectHome",
  "SinchDashboardDashboard",
  "SinchDashboardSettings",
  "SinchDashboardAccount",
  "SinchDashboardAccountDetails",
  "SinchDashboardSidebar",
  "SinchDashboardSidebarMobile",
  "SinchDashboardTopbar",
  "SinchDashboardInvite",
  "SinchDashboardConvapi",
  "SinchDashboardBilling",
  "SinchDashboardKakaotalk",
  "SinchDashboardProjects",
  "SinchDashboardPayment",
  "SinchDashboardOnboarding",
  "SinchDashboardNumbers",
  "SinchDashboardFax",
  "SinchDashboardMms",
  "SinchDashboardNumberLookup",
  "SinchDashboardPublic",
  "SinchDashboardRcs",
  "SinchDashboardTrunks",
  "SinchDashboardSidekick",
  "SinchDashboardPushNotifications",
  "SinchDashboardSinchChat",
  "SinchDashboardSms",
  "SinchDashboardVerification",
  "SinchDashboardViber",
  "SinchDashboardVerify",
  "SinchDashboardVoiceV2",
  "SinchDashboardWhatsapp",
  "SinchDashboardVoice",
  "SinchAccountHome",
  "SinchDashboardOverlays",
  "SinchDashboard404",
  "ShieldMessageReview",
  "MessageMediaContactsV2",
  "MessageMediaExtensions",
  "MessageMediaUpgrade",
  "MessageMediaPublicFacing",
  "WebWidgets",
  "MenuPlugin",
  "MessageMediaReports",
  "AgenticConversationsMFE",
  "TestIamPermissionsPlugin",
  "engage-autoresponders-keywords",
  "SenderRegistration",
  "SinchDashboardFunctions",
] as const;

export const remoteNameZod = z.enum([...mfeNames]);
export type RemoteName = z.infer<typeof remoteNameZod>;
export type MfeConfig = Record<
  string,
  { url: string; flags?: string[] | undefined }
>;

export const MFE_OVERRIDE_KEY = "_mfe";
export const MFE_VARIANT_OVERRIDE_KEY = "_variant";

const getEngageUrls = () =>
  Object.entries(engageApps).reduce<MfeConfig>(
    (acc, [consumerName, remote]) => {
      const [remoteName, mfeDomainFrag] = remote.split("@");
      const remoteUrl = `https://${mfeDomainFrag}${config.ENGAGE_MFE_BASE_DOMAIN}`;
      if (remoteName && remoteUrl) {
        return { ...acc, [consumerName]: { url: remoteUrl } };
      }
      return acc;
    },
    {}
  );

const getMessageMediaUrls = () => {
  const baseConfig =
    ENTRY === "mm" && !location.hostname.includes("localhost")
      ? mmApps
      : mmAppsLocal;

  // Handles temporary mm lab deployments
  const hostName = window.location.hostname.includes(
    "mm.web.labengage.sinch.com"
  )
    ? "onesaas-stg-syd-hub.s3.ap-southeast-2.amazonaws.com"
    : window.location.hostname;

  return Object.entries(baseConfig).reduce<MfeConfig>(
    (acc, [consumerName, remote]) => {
      const [remoteName, mfeDomainFrag] = remote.split("@");

      const remoteUrl = mfeDomainFrag?.includes("localhost")
        ? `http://${mfeDomainFrag}`
        : `https://${hostName}/${mfeDomainFrag}`;
      if (remoteName && remoteUrl) {
        return { ...acc, [consumerName]: { url: remoteUrl } };
      }

      return acc;
    },
    {}
  );
};

export const getBaseMfeConfig = () => ({
  ...getEngageUrls(),
  ...getMessageMediaUrls(),
});
